import { render, staticRenderFns } from "./TabStub.vue?vue&type=template&id=64af404c&scoped=true&"
var script = {}
import style0 from "./TabStub.vue?vue&type=style&index=0&id=64af404c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64af404c",
  null
  
)

export default component.exports